<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>设备列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="12">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px;" @clear="getmacList" @change="getmacList">
            <el-button slot="append" icon="el-icon-search" @click="getmacList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="12"  style="text-align: right;" >
                    <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
                </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-card class="card_zhongduan_list" id="report">
            <div class="tag-group002" v-for="item0 in macList" :key="item0.id">
              <div class="mac" style="height: 20px;">机器编号:{{ item0.mac_bianhao }}</div>
              <div class="qrCodeUrl" id="qrCodeUrl" ref="qrCodeUrl"></div>
              <div class="class_port"></div>
              <div class="class_port">
                <el-card class="card_zhongduan">
                  <div class="tag-group" v-for="item in show_duohang" :key="item.id">

                    <el-tooltip placement="right-start" v-for="item2 in item0.portList.slice(item.start, item.end)"
                      :content="'名称:' + item2.mac_port_name" :key="item2.uid" effect="light">
                      <!-- <el-button :type="item2.yong_flag === 1 ? 'success' : 'warning'">{{ item2.mac_port_name }}</el-button> -->
                      <Erweima :port_name="item2.mac_port_name" :uid="item2.uid" />

                    </el-tooltip>
                  </div>
                </el-card>
              </div>
            </div>
          </el-card>

        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>

    </el-card>

  </div>
</template>
<script>
import { checkMobileTest } from './config/validator.js'
import Erweima from './ewm'
import QRCode from 'qrcodejs2'
import exportExcel from './config/exportExcel'
export default {
  components: {
    Erweima
  },
  props: [
    //  已分配设备管理标记
    'caozuo_flag_props' // 操作类型   
  ],
  data() {
    return {
      // 获取用户列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'mac_kucun_list_sx002',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      show_duohang: [
        { id: 0, start: 0, end: 5 },
        { id: 1, start: 5, end: 10 },
        { id: 2, start: 10, end: 15 },
        { id: 3, start: 15, end: 20 }
      ],
      qiyeList: [],
      macList: [],
      macTypeList: [],
      macPortList: [],
      zhandianList: [],
      caozuo_nei_flag: 0, // 修改设备信息还是更新门店标记

      total: 0,
      add_isDisable: false,
      addPiliang_isDisable: false,
      addDialogVisible: false,
      addPiliangDialogVisible: false,
      editDialogVisible: false,
      editZhandianVisible: false,
      controlDialogVisible: false,
      EwmDialogVisible: false,
      //  添加表单数据项
      addForm: {
        C_type: 'mac_kucun_add',
        mac_bianhao: '',
        mac_xuliehao: '',
        mac_qiye_uid: '',
        mac_name: '',
        mac_type_uid: ''
      },
      addPiliangForm: {
        C_type: 'mac_kucun_add_piliang',
        mac_qiye_uid: '',
        mac_name: '',
        mac_type_uid: '',
        mac_count: 1
      },
      // 用于修改数据绑定
      editForm: {},
      mac_select_xuhao: 0,
      controlForm: {

      },
      updateQueryStr: '',
      mac_bianhao_ewm: '',
      caozuo_flag: 0, // 该标记为操作类型标记 1 正常的修改操作 2 管理员 机器分配给 门店操作    3 门店 把机器 绑定到站点操作 
      edit_title: ''
      // 表单规则项
    };
  },
  created() {
    this.getmacList();
  },
  methods: {
    handleExport() {
      exportExcel('report', '导出.xlsx')
    },
    async getmacList() {
      this.queryInfo.C_table_name = 'mac_mac_list_ewm'
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      // console.log(JSON.parse(res.data))
      this.macList = JSON.parse(res.data)[0].dataList
      if (!this.macList) return
      this.total = JSON.parse(res.data)[0].total;
      console.log(this.macList)
    },
    //  分页第一项下拉触发
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getmacList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      var queryInfo = {}
      this.queryInfo.pageNum = newPage;
      this.getmacList();
    },

    creatQrCode(macUid) {
      var httpApi = window.sessionStorage.getItem('http_api')
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        // https://test.pzeiot.com:802/img/xuanchuan.html
        text: httpApi + '/img2/xuanchuan.html?C_type=saoma_mac&type=1&mac_uid=' + macUid + '&pro_uid=1', // 次数为直接扫机器，生成的机器二维码
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}

.el_row_two {
  margin-top: 30px;
}

.bg-purple-light {
  background: #f2f3f7;
}

.grid-content {
  border-radius: 6px;
  min-height: 36px;
  text-align: center;
  height: 80px;

}

.bg-purple {
  background: rgb(252, 248, 230);
}

.bg-null {
  background: #fff;
}

.mac_info {

  margin-left: 20px;
  text-align: left;
}

.mac_info2 {
  margin-top: 12px;
  margin-left: 20px;
  text-align: center;

}

.left_title {
  margin-right: 5px;
}

.mac {
  padding-top: 10px;
  text-align: center;
}

.title_xianlu {
  text-align: center;
  background: rgb(194, 220, 241);
  width: 100px;
  height: 20px;
  border-top-right-radius: 5px;

}

.switch_lu {
  text-align: center;

  width: 100px;
  height: 20px;
  border-top-right-radius: 5px;

}

.qrCodeUrl {
  display: flex;
  justify-content: center;
}

.qrCodeUrl img {

  padding: 61px; // 利用padding的特性，挤出白边
  border: #f00;
  box-sizing: border-box;
}

.mac {
  text-align: center;
}

.tag-group {

  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

}

.tag-group002 {

  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

.card_zhongduan {
  background: #f9f9f9;
  width: 100%;
}

.class_port {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.card_zhongduan_list {
  display: flex;
  flex-direction: column;
  justify-content: center;
}</style>
